import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

export interface IncidentContactInfo {
  contactId: string;
  bpid?: string;
  fistName?: string;
  lastName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  langCountryId?: string;
  name?: string;
}

export interface Incident {
  _id: mongoose.Schema.Types.ObjectId;
  _text: string;
  caseNumber: string;
  itsmCustomerId: string;
  category: string;
  subcategory?: string;
  channel: string;
  state?: string;
  customerTicketNumber?: string;
  serialNumber?: string;
  shortDescription: string;
  contactPerson?: string;
  contactInfo?: IncidentContactInfo;
  alternateContactInfo?: IncidentContactInfo;
  contactName?: string;
  created?: string | Date;
  updated?: string | Date;
  userEmail: string;
  rejectionReason: string;
}

export const IncidentSchema = new mongoose.Schema<Incident>({
  _text: String,
  caseNumber: { type: String, index: true, unique: true }, // unique
  itsmCustomerId: { type: String, index: true },
  category: { type: String, index: true },
  subcategory: String,
  channel: String,
  state: String,
  customerTicketNumber: String,
  serialNumber: String,
  shortDescription: String,
  contactPerson: { type: String, index: true }, // contact ID
  contactInfo: {
    _id: false,
    contactId: String,
    bpid: String,
    firstName: String,
    lastName: String,
    emailAddress: String,
    phoneNumber: String,
    langCountryId: String,
    name: String,
  },
  alternateContactInfo: {
    _id: false,
    contactId: String,
    bpid: String,
    firstName: String,
    lastName: String,
    emailAddress: String,
    phoneNumber: String,
    langCountryId: String,
    name: String,
  },
  contactName: String, // Name extracted from contactInfo for better search
  created: mongoose.Schema.Types.Mixed, // should be Date eventually
  updated: mongoose.Schema.Types.Mixed, // should be Date eventually
  userEmail: String,
  rejectionReason: String
});

IncidentSchema.index({
  "itsmCustomerId": 1,
  "contactInfo": 1,
  "contactPerson": 1,
});

IncidentSchema.index({
  "itsmCustomerId": 1,
  "contactInfo": 1,
  "contactName": 1,
  "contactPerson": 1,
});

export const props: (keyof Incident)[] = [
  "_text",
  "caseNumber",
  "itsmCustomerId",
  "category",
  "subcategory",
  "channel",
  "state",
  "customerTicketNumber",
  "serialNumber",
  "shortDescription",
  "contactPerson",
  "contactInfo",
  "alternateContactInfo",
  "contactName",
  "created",
  "updated",
  "userEmail",
  "rejectionReason"
];

export const searchProps: (keyof Incident)[] = [
  "_text",
  "caseNumber",
  "category",
  "subcategory",
  "channel",
  "state",
  "customerTicketNumber",
  "serialNumber",
  "shortDescription",
  "contactName",
  "created",
  "updated",
  "userEmail",
];

export const filterProps: (keyof Incident)[] = [
  "category",
  "subcategory",
  "state",
  "created",
];

export function matches(a: Incident, b: Incident): boolean {
  return match(a, b, props);
}

export const incidentUtils = {
  matches,
  props,
  searchProps,
  filterProps,
}
